import type { SearchData } from "../types";
import { getTodayDate } from "../utils/Date";

export const SEARCH_RESULTS_PAGE_SIZE = 10;

export const INITIAL_SESSION_SEARCH_DATA: SearchData = {
  cnr: "",
  highCourt: "",
  state: "",
  district: "",
  courtComplex: "",
  courtName: "",
  date: getTodayDate(),
  status: "all",
  highcourt: "",
  bench: "",
  benchRoom: "",
  establishment: "",
};
